export class ChSmartGridCell {
    constructor() {
        this.cellId = undefined;
        this.smartGridRef = undefined;
    }
    #actualSmartGridRef;
    el;
    /**
     * Fired when the component and all its child did render for the first time.
     *
     * It contains the `cellId`.
     */
    smartCellDidLoad;
    connectedCallback() {
        this.el.setAttribute("role", "gridcell");
        this.#actualSmartGridRef =
            this.smartGridRef ?? this.el.closest("ch-smart-grid");
    }
    componentDidLoad() {
        this.smartCellDidLoad.emit(this.cellId);
        // DOM write operation
        this.el.setAttribute("data-did-load", "true");
    }
    disconnectedCallback() {
        this.#actualSmartGridRef.dispatchEvent(new CustomEvent("smartCellDisconnectedCallback", { detail: this.el }));
    }
    static get is() { return "ch-smart-grid-cell"; }
    static get originalStyleUrls() {
        return {
            "$": ["smart-grid-cell.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["smart-grid-cell.css"]
        };
    }
    static get properties() {
        return {
            "cellId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the ID of the cell.\n\nWe use a specific property instead of the actual id attribute, because\nwith this property we don't need this ID to be unique in the Shadow scope\nwhere this cell is rendered. In other words, if there is an element with\n`id=\"1\"`, this cell can still have `cellId=\"1\"`."
                },
                "attribute": "cell-id",
                "reflect": true
            },
            "smartGridRef": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChSmartGridElement",
                    "resolved": "HTMLChSmartGridElement",
                    "references": {
                        "HTMLChSmartGridElement": {
                            "location": "global",
                            "id": "global::HTMLChSmartGridElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Specifies the reference for the smart grid parent.\n\nThis property is useful to avoid the cell from queering the ch-smart-grid\nref on the initial load."
                }
            }
        };
    }
    static get events() {
        return [{
                "method": "smartCellDidLoad",
                "name": "smartCellDidLoad",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the component and all its child did render for the first time.\n\nIt contains the `cellId`."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
